<div class="sk-container" [ngClass]="{ 'sk-loading': isNotAllModulesLoaded && !state.error }" [style.min-height.vh]="100">
    @if (!state.error) {
        <div class="heuristic-container" [style.min-height.vh]="100">
            <!--- Featured Modules -->
            <lazy-component
                moduleUri="@featuredModule/featured.module#FeaturedModule"
                [inputs]="{ sportId: sportId, sportName: sportName, shouldDisplayLoader: false, isGolfMatchesTab: isGolfMatchesTab }"
                [outputs]="['isLoadedEvent', 'featuredEventsCount']"
                (event)="updateLoadStatus(0, $event)"
                data-crlat="tab.showFeaturedContent">
            </lazy-component>
            <!-- Time | League Filters -->
            <div [style.min-height.px]="isFiltersEnables ? 45 : 0">
                @if (isSportEventFiltersEnabled && competitionFilters.length && displayFilters) {
                    <lazy-component
                        data-crlat="competitionFilters"
                        moduleUri="@lazy-modules-module/competitionFilters/competitionFilters.module#CompetitionFiltersModule"
                        [inputs]="{ filters: competitionFilters, sportId: sportId, paddingTop: true }"
                        [outputs]="['filterChange']"
                        (event)="handleCompetitionFilterOutput($event)"></lazy-component>
                }
            </div>
            @if (isFeaturedLoaded) {
                <sport-matches-tab
                    #SportMatchesTab
                    [sport]="sport"
                    [featuredEventsCount]="featuredEventsCount"
                    [timeFilter]="timeFilter"
                    [leagueFilter]="leagueFilter"
                    [isSportEventFiltersEnabled]="isSportEventFiltersEnabled"
                    [targetTab]="targetTab"
                    (isLoadedEvent)="updateLoadStatus(1, $event)"
                    (displayFilters)="updateFiltersDisplay($event)"
                    data-crlat="accordionsList">
                </sport-matches-tab>
            }
        </div>
    }
</div>
